import type React from 'react'

import { ContainerStyled } from './styles'

interface ContainerProps {
  fullwidth?: boolean
  children?: React.ReactNode
}

export const Container: React.FC<ContainerProps> = ({ children, fullwidth = false }) => (
  <ContainerStyled disableGutters fullwidth={fullwidth ? 'true' : 'false'} maxWidth="lg">
    {children}
  </ContainerStyled>
)
